














































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
  name: "SelectorMulti",
})
export default class Selector extends Vue {
  @Prop({
    type: Boolean,
    default() {
      return;
    },
  })
  required!: boolean;
  @Prop({
    type: Array,
  })
  items!: object[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  value!: object[];
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  label!: string;
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  defaultItem!: string;
  @Prop({
    type: Boolean,
    default() {
      return false;
    },
  })
  selectType!: boolean;

  @Watch('value')
  clearItem(newVal: any) {
    if (newVal.length > 1) {
      if (this.itemValue.findIndex((el:any) => el.id === this.defaultItem) !== -1) {
        if (this.itemValue.findIndex((el:any) => el.id === this.defaultItem) === this.itemValue.length-1) {
          if(this.selectType) {
            this.itemValue = [{id: "all", text: this.$t('shardList.filter.filter_data.items.all')}]
          } else {
            this.itemValue = [{id: "all", text: this.$t('shardList.filter.filter_fio.items.all')}]
          }
        } else {
          this.itemValue = newVal
          this.itemValue.splice(this.itemValue.findIndex((el:any) => el.id === this.defaultItem),1)
        }

      } else {
        this.itemValue = newVal

      }
    }
    if (newVal.length === 0) {
      if(this.selectType) {
        this.itemValue.push({id: "all", text: this.$t('shardList.filter.filter_data.items.all')})
      } else {
        this.itemValue.push({id: "all", text: this.$t('shardList.filter.filter_fio.items.all')})
      }
    }

    this.$emit("input", this.itemValue);
  }

  activeIcon(item: any) {
    let flag = false
    this.itemValue.forEach((currentItem: any) => {
      if(currentItem.id == item.id) {
        flag = true
      }
    })
    return flag
  }


  // data
  private classes: any = {
    "lfs-pd-input-block-requred": this.required,
  };
  itemValue: object[] = this.value;

  deleteItem(item:any) {
   this.itemValue.splice(this.itemValue.indexOf(item),1)
    this.$emit("input", this.itemValue);
  }

  handleInput() {
    this.$emit("input", this.itemValue);
  }
}
